import React from 'react';
import { PointSelection } from './types';

type PointSummaryProps = {
  title: string;
  emptyLabel: string;
  selection: PointSelection;
  onAdd: () => void;
  onClear: () => void;
};

export const PointSummary: React.FC<PointSummaryProps> = ({
  title,
  emptyLabel,
  selection,
  onAdd,
  onClear,
}) => (
  <div className="border rounded p-2">
    <div className="d-flex justify-content-between align-items-center mb-2">
      <span className="fw-semibold">{title}</span>
      <div className="d-flex gap-2">
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm"
          onClick={onAdd}
        >
          Add
        </button>
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm"
          onClick={onClear}
          disabled={selection.ids.length === 0}
        >
          Clear
        </button>
      </div>
    </div>
    <small className="text-muted d-block mb-1">Selected: {selection.ids.length}</small>
    <div className="d-flex flex-wrap gap-1">
      {selection.ids.length === 0 && <small className="text-muted">{emptyLabel}</small>}
      {selection.ids.map((id) => (
        <span key={`${title}-${id}`} className="badge text-bg-light border">
          {selection.names[id] || 'Unnamed point'}
        </span>
      ))}
    </div>
  </div>
);
